$.fn.preload = function() {
    this.each(function() {
        $('<img/>')[0].src = 'resources/themes/nzhearing/build/images/' + this;
    });
}

$(['loading.gif']).preload();
